import React from 'react';
import './ltv-area.css';
import axios from 'axios';
import { baseUrl } from '../../assets/Animations';
import {getRequestHeaders} from '../../api';

const LTVArea = () => {
    const [invoices, setInvoices] = React.useState([]);
    const [families, setFamilies] = React.useState([]);
    const [ltv, setLTV] = React.useState(0);
    const [instrumentLTV, setInstrumentLTV] = React.useState({});

    React.useEffect(() => {
        axios.get(`${baseUrl}/allinvoices`, getRequestHeaders()) 
        .then(res => {
            setInvoices(res.data);
        })
        .catch(err => {
            console.log(err);
        })
        axios.get(`${baseUrl}/school-management`, getRequestHeaders())
        .then(res => {
            setFamilies(res.data);
        })
        .catch(err => {
            console.log(err);
        })
    }, [])

    React.useEffect(() => {
        console.log(instrumentLTV)
    }, [instrumentLTV])

    React.useEffect(() => {
        if(invoices.length > 0 && families.length > 0) {
            calculateLTV();
            //calculateInstrumentLTV()
        }
    }, [invoices, families])

    const calculateLTV = () => {
        //create an object where the key is the familyId and the value is the total amount spent
        const familyTotals = {};
        invoices.forEach(invoice => {
            calculateInvoiceTotal(invoice);
            if(familyTotals[invoice.familyId]) {
                familyTotals[invoice.familyId] += calculateInvoiceTotal(invoice);
            } else {
                familyTotals[invoice.familyId] = calculateInvoiceTotal(invoice);
            }
        });
        setLTV(processFamilyTotals(familyTotals))
        processFamilyTotalsForInstrumentLTV(familyTotals)
    }

    const processFamilyTotalsForInstrumentLTV = (familyTotals) => {
        let allInstrumentLTVs = {};
        let totalFamiliesThatPlayThatInstrument = 0
        let totalIncome = 0
        Object.keys(familyTotals).forEach(familyId => {
            //get the instrument that the family plays
            const family = findFamilyById(familyId);
            const instruments = getInstrumentsFromFamily(family);
            let newTotal = familyTotals[familyId] / instruments.length;
            instruments.forEach(instrument => {
                if(allInstrumentLTVs[instrument]) {
                    allInstrumentLTVs[instrument]['revenue'] += newTotal;
                    allInstrumentLTVs[instrument]['families']++;
                } else {
                    allInstrumentLTVs[instrument] = {};
                    allInstrumentLTVs[instrument]['revenue'] = newTotal;
                    allInstrumentLTVs[instrument]['families'] = 1;
                }
            })
        })
        Object.keys(allInstrumentLTVs).forEach(instrument => {
            //round to two decimal places
            allInstrumentLTVs[instrument]['revenue'] = Math.round(allInstrumentLTVs[instrument]['revenue'] * 100) / 100;
            allInstrumentLTVs[instrument]['ltv'] = Math.round(allInstrumentLTVs[instrument]['revenue'] / allInstrumentLTVs[instrument]['families']);
        })
        //order the object by ltvs
        let orderedInstrumentLTVs = {};
        Object.keys(allInstrumentLTVs).sort((a, b) => allInstrumentLTVs[b]['ltv'] - allInstrumentLTVs[a]['ltv']).forEach(key => {
            orderedInstrumentLTVs[key] = allInstrumentLTVs[key];
        })
        setInstrumentLTV(orderedInstrumentLTVs)
    }



    const processFamilyTotals = (familyTotals) => {
        let totalFamilies = 0
        let totalIncome = 0
        Object.keys(familyTotals).forEach(familyId => {
            if(familyTotals[familyId] > 25) {
                totalFamilies++;
                totalIncome += familyTotals[familyId];
            }
        })
        let ltr = totalIncome / totalFamilies;
        let ltv = ltr * .55
        let roundedLTV = Math.round(ltv * 100) / 100;
        return roundedLTV;
    }

    // const calculateInstrumentLTV = () => {
    //     const familyTotals = {};
    
    //     invoices.forEach(invoice => {
    //         // Fetch corresponding family from StudentTwo collection based on familyId
    //         const family = findFamilyById(invoice.familyId);
    
    //         if (family) {
    //             // Add instrument information to the invoice
    //             invoice.instrument = getInstrumentsFromFamily(family, invoice.familyId);
    
    //             // Calculate and accumulate total amount spent
    //             const totalAmount = calculateInvoiceTotal(invoice);
    //             if (familyTotals[invoice.instrument]) {
    //                 familyTotals[invoice.instrument] += totalAmount;
    //             } else {
    //                 familyTotals[invoice.instrument] = totalAmount;
    //             }
    //         }
    //     });
    //     console.log(sortFamilyTotals(familyTotals))
    //     //setLTV(processFamilyTotals(familyTotals));
    // };

    const sortFamilyTotals = (familyTotals) => {
        const sortedFamilyTotals = [];
        for (let instrument in familyTotals) {
            sortedFamilyTotals.push([instrument, familyTotals[instrument]]);
        }
        sortedFamilyTotals.sort((a, b) => b[1] - a[1]);
        return sortedFamilyTotals;
    }
    
    // Helper function to find family by familyId in StudentTwo collection
    const findFamilyById = (familyId) => {
        for (let i = 0; i < families.length; i++) {
            if (families[i].familyId === familyId) {
                return families[i];
            }
        }
    };
    
    // Helper function to get instrument information from family
    const getInstrumentsFromFamily = (family) => {
        if(!family) return [];
        let instruments = []
        for(let i = 0; i < family.students.length; i++) {
            for(let j = 0; j < family.students[i].instrumentList.length; j++) {
                //push instrument into instruments array
                instruments.push(family.students[i].instrumentList[j].name)
            }
        }

        return instruments;
    };
    




    const calculateInvoiceTotal = (invoice) => {
        let total = 0
        invoice.lessonsToBeBilled.forEach(lesson => {
            let rates = lesson.studentAllRates ? lesson.studentAllRates : {15: 22, 30: 45, 45: 60, 60: 75};
            if(!lesson.lessonLength) {
                total += rates[30]
            } else if (lesson.lessonLength === 31 || lesson.lessonLength === 46 || lesson.lessonLength === 61) {
                let introRates = {31: 25, 46: 35, 61: 45}
                total += introRates[lesson.lessonLength]
            }
            else {
                total += rates[lesson.lessonLength]
            }
        })
        return total;
    }


    return (
        <div className='ltv-area__wrapper'>
            <div className='ltv-area'>LTV: ${ltv}</div>
            <div>LTV By Instrument:</div>
            <div>
                {Object.keys(instrumentLTV).map(ltvInstrument => 
                    <div>{ltvInstrument}: ${instrumentLTV[ltvInstrument]['ltv']} |||  ${instrumentLTV[ltvInstrument]['revenue']} ||| {instrumentLTV[ltvInstrument]['families']}</div>
                )}
            </div>
            <div>LTV By Town:</div>
        </div>
    )
}
export default LTVArea;